import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const InspectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 0;
`;

export const InspectionItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  ${({ wrapperStyles }) => wrapperStyles && { ...wrapperStyles }};
`;

export const InspectionItemText = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  span{
    font-weight: 500;
  }
`;

export const IconContainer = styled.div`
  min-height: 24px;
  min-width: 24px;
  object-fit: contain;
`;
